import _toConsumableArray from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";

function processQueue(router, routerQueue, routeQueue, to, from, resolve, reject) {
  var queue = [];

  if (Array.isArray(routeQueue)) {
    queue.push.apply(queue, _toConsumableArray(routeQueue));
  } else if (routeQueue && typeof routeQueue === 'function') {
    queue.push(routeQueue);
  }

  if (routerQueue) {
    if (Array.isArray(routerQueue)) {
      queue.push.apply(queue, _toConsumableArray(routerQueue));
    } else {
      queue.push(routerQueue);
    }
  }

  function next() {
    if (queue.length === 0) {
      resolve();
      return;
    }

    var queueItem = queue.shift();
    queueItem.call(router, to, from, function () {
      next();
    }, function () {
      reject();
    });
  }

  next();
}

export default function (to, from, resolve, reject) {
  var router = this;

  function enterNextRoute() {
    if (to && to.route && (router.params.routesBeforeEnter || to.route.beforeEnter)) {
      router.allowPageChange = false;
      processQueue(router, router.params.routesBeforeEnter, to.route.beforeEnter, to, from, function () {
        router.allowPageChange = true;
        resolve();
      }, function () {
        reject();
      });
    } else {
      resolve();
    }
  }

  function leaveCurrentRoute() {
    if (from && from.route && (router.params.routesBeforeLeave || from.route.beforeLeave)) {
      router.allowPageChange = false;
      processQueue(router, router.params.routesBeforeLeave, from.route.beforeLeave, to, from, function () {
        router.allowPageChange = true;
        enterNextRoute();
      }, function () {
        reject();
      });
    } else {
      enterNextRoute();
    }
  }

  leaveCurrentRoute();
}